import React from 'react';
import NewCard from './Modal/NewCard';
import FullPageLoader from '../../../../utils/FullPageLoader';
import routes from '../../../../Routes/routes';
import HeadTittle from '../../../../components/HeadTittle';
import DivContainerBody from '../../../../components/DivContainerBody';
import EmployeeApp from './Functionality/EmployeeApp';
import CopySecretModal from './Modal/CopySecretModal';
import { permissionObj } from '../../../../Helpers/permission';
import CreateEmployeeWithoutExtraData from './SubComponents/CreateEmployeeWithoutExtraData';
import CreateEmployeeWithExtraData from './SubComponents/CreateEmployeeWithExtraData';

const CreateEmployee = () => {
    const {
        contractorId,
        supplierId,
        DEV,
        permission,
        navigate,
        disabled,
        headersList,
        employeeRoles,
        employeeWorkStations,
        contractStatusList,
        employeeDepartments,
        steps,
        activeStep,
        setActiveStep,
        loadingProgress,
        extraDataEnabled,
        emptyFields,
        userData,
        setUserData,
        isValidEmail,
        isValidDocumentId,
        isValidPin,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        createEmployeeEmail,
        extraData,
        setExtraData,
        employeeData,
        setEmployeeData,
        isValidStartDate,
        setIsValidStartDate,
        isValidEndDate,
        setIsValidEndDate,
        workShiftsList,
        setWorkShiftsList,
        customizedList,
        setCustomizedList,
        setSelectedReader,
        capturedFingerprint,
        setCapturedFingerprint,
        fingerprintsList,
        fingerprintName,
        setFingerprintName,
        fingerprintSrc,
        setFingerprintSrc,
        setUpdated,
        updatedFinger,
        capturing,
        setCapturing,
        selfieSrc,
        selectedImage,
        newCardModal,
        setNewCardModal,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setModified,
        photoPickerFile,
        setPhotoPickerFile,
        handleFormChangeUserData,
        handleFormChangeExtraData,
        handleFormChangeEmployeeData,
        handleStepChange,
        handleCreateEmployee,
        handleClearExtraData,
        handleClearUserData,
        handleClearEmployeeData,
        handleUploadFinger,
        handleValidationStepDetails,
        handleValidationContract,
        isPilgrimsValidation,
        handleValidationSelfie,
        emptySelfie,
        setEmptyFields,
        resetForm,
        t,
        fingerprintsTemp,
        setFingerprintsTemp,
        mergedFingerprints,
        isValidCecoCode,
        cardsList,
        setCardsList
    } = EmployeeApp();

    if (
        contractorId === null &&
        supplierId === null &&
        !DEV &&
        !permission?.includes(permissionObj?.WEB_EMPLOYEE_CREATE)
    )
        navigate(routes.forbidden);
    return (
        <>
            {loadingProgress && <FullPageLoader />}
            <HeadTittle link={routes.employee.list} name={'create'} />

            <DivContainerBody>
                {extraDataEnabled ? (
                    <CreateEmployeeWithExtraData
                        disabled={disabled}
                        steps={steps}
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                        handleClearUserData={handleClearUserData}
                        userData={userData}
                        handleFormChangeUserData={handleFormChangeUserData}
                        emptyFields={emptyFields}
                        isValidEmail={isValidEmail}
                        isValidDocumentId={isValidDocumentId}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        isValidPin={isValidPin}
                        createEmployeeEmail={createEmployeeEmail}
                        handleValidationStepDetails={handleValidationStepDetails}
                        extraData={extraData}
                        handleFormChangeExtraData={handleFormChangeExtraData}
                        setExtraData={setExtraData}
                        headersList={headersList}
                        handleClearExtraData={handleClearExtraData}
                        employeeData={employeeData}
                        employeeRoles={employeeRoles}
                        employeeWorkStations={employeeWorkStations}
                        contractStatusList={contractStatusList}
                        employeeDepartments={employeeDepartments}
                        isValidStartDate={isValidStartDate}
                        setIsValidStartDate={setIsValidStartDate}
                        isValidEndDate={isValidEndDate}
                        setIsValidEndDate={setIsValidEndDate}
                        handleFormChangeEmployeeData={handleFormChangeEmployeeData}
                        setEmployeeData={setEmployeeData}
                        handleClearEmployeeData={handleClearEmployeeData}
                        isPilgrimsValidation={isPilgrimsValidation}
                        handleValidationContract={handleValidationContract}
                        workShiftsList={workShiftsList}
                        setWorkShiftsList={setWorkShiftsList}
                        customizedList={customizedList}
                        setCustomizedList={setCustomizedList}
                        resetForm={resetForm}
                        photoPickerFile={photoPickerFile}
                        setPhotoPickerFile={setPhotoPickerFile}
                        emptySelfie={emptySelfie}
                        handleValidationSelfie={handleValidationSelfie}
                        t={t}
                        capturing={capturing}
                        setCapturing={setCapturing}
                        capturedFingerprint={capturedFingerprint}
                        setCapturedFingerprint={setCapturedFingerprint}
                        fingerprintSrc={fingerprintSrc}
                        setFingerprintSrc={setFingerprintSrc}
                        updatedFinger={updatedFinger}
                        setFingerprintName={setFingerprintName}
                        setSelectedReader={setSelectedReader}
                        fingerprintsList={fingerprintsList}
                        setUpdated={setUpdated}
                        setModified={setModified}
                        fingerprintName={fingerprintName}
                        fingerprintsTemp={fingerprintsTemp}
                        setFingerprintsTemp={setFingerprintsTemp}
                        handleUploadFinger={handleUploadFinger}
                        mergedFingerprints={mergedFingerprints}
                        setEmptyFields={setEmptyFields}
                        extraDataEnabled={extraDataEnabled}
                        selectedImage={selectedImage}
                        selfieSrc={selfieSrc}
                        handleCreateEmployee={handleCreateEmployee}
                        isValidCecoCode={isValidCecoCode}
                        cardsList={cardsList}
                        setCardsList={setCardsList}
                    />
                ) : (
                    <CreateEmployeeWithoutExtraData
                        disabled={disabled}
                        steps={steps}
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                        handleClearUserData={handleClearUserData}
                        userData={userData}
                        handleFormChangeUserData={handleFormChangeUserData}
                        emptyFields={emptyFields}
                        isValidEmail={isValidEmail}
                        isValidDocumentId={isValidDocumentId}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDob={isValidDob}
                        setIsValidDob={setIsValidDob}
                        isValidPin={isValidPin}
                        createEmployeeEmail={createEmployeeEmail}
                        handleValidationStepDetails={handleValidationStepDetails}
                        employeeData={employeeData}
                        employeeRoles={employeeRoles}
                        employeeWorkStations={employeeWorkStations}
                        contractStatusList={contractStatusList}
                        employeeDepartments={employeeDepartments}
                        isValidStartDate={isValidStartDate}
                        setIsValidStartDate={setIsValidStartDate}
                        isValidEndDate={isValidEndDate}
                        setIsValidEndDate={setIsValidEndDate}
                        handleFormChangeEmployeeData={handleFormChangeEmployeeData}
                        setEmployeeData={setEmployeeData}
                        handleClearEmployeeData={handleClearEmployeeData}
                        isPilgrimsValidation={isPilgrimsValidation}
                        handleValidationContract={handleValidationContract}
                        workShiftsList={workShiftsList}
                        setWorkShiftsList={setWorkShiftsList}
                        customizedList={customizedList}
                        setCustomizedList={setCustomizedList}
                        resetForm={resetForm}
                        photoPickerFile={photoPickerFile}
                        setPhotoPickerFile={setPhotoPickerFile}
                        emptySelfie={emptySelfie}
                        handleValidationSelfie={handleValidationSelfie}
                        t={t}
                        capturing={capturing}
                        setCapturing={setCapturing}
                        capturedFingerprint={capturedFingerprint}
                        setCapturedFingerprint={setCapturedFingerprint}
                        fingerprintSrc={fingerprintSrc}
                        setFingerprintSrc={setFingerprintSrc}
                        updatedFinger={updatedFinger}
                        setFingerprintName={setFingerprintName}
                        setSelectedReader={setSelectedReader}
                        fingerprintsList={fingerprintsList}
                        setUpdated={setUpdated}
                        setModified={setModified}
                        fingerprintName={fingerprintName}
                        fingerprintsTemp={fingerprintsTemp}
                        setFingerprintsTemp={setFingerprintsTemp}
                        handleUploadFinger={handleUploadFinger}
                        mergedFingerprints={mergedFingerprints}
                        setEmptyFields={setEmptyFields}
                        extraData={extraData}
                        extraDataEnabled={extraDataEnabled}
                        selectedImage={selectedImage}
                        selfieSrc={selfieSrc}
                        headersList={headersList}
                        handleCreateEmployee={handleCreateEmployee}
                        isValidCecoCode={isValidCecoCode}
                        cardsList={cardsList}
                        setCardsList={setCardsList}
                    />
                )}
            </DivContainerBody>
            <NewCard title='New Card' show={newCardModal} onHide={() => setNewCardModal(false)} />

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUserData}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.employee.list);
                }}
                closeText={'continue'}
            />
        </>
    );
};
export default CreateEmployee;
